import React from 'react';
import { Card, Button, Input, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { TaskComment } from '../../services/tasks';

const { Text } = Typography;
const { TextArea } = Input;

interface CommentTabProps {
  isEdit: boolean;
  comments: TaskComment[];
  commentText: string;
  setCommentText: React.Dispatch<React.SetStateAction<string>>;
  handleAddComment: () => void;
  handleDeleteComment: (commentId: number | string) => void;
  formatDateTime: (dateString?: string) => string;
}

export const CommentTab: React.FC<CommentTabProps> = ({
  isEdit,
  comments,
  commentText,
  setCommentText,
  handleAddComment,
  handleDeleteComment,
  formatDateTime,
}) => {
  return (
    <Card title="Comments" bodyStyle={{ padding: '16px' }}>
      <div style={{ marginBottom: 16 }}>
        {comments.map((comment, index) => (
          <div
            key={comment.id || index}
            style={{
              padding: '12px 0',
              borderBottom: '1px solid #f0f0f0',
            }}
          >
            <div style={{ marginBottom: 8, whiteSpace: 'pre-wrap' }}>
              <Text>{comment.comment || '-'}</Text>
            </div>
            <div style={{ fontSize: '12px', color: '#999' }}>
              By {comment.user?.name || comment.creator?.name || 'Unknown'} • {formatDateTime(comment.created_at)}
              {isEdit && (
                <Button
                  type="link"
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteComment(comment.id!)}
                  style={{ marginLeft: 8, padding: 0 }}
                />
              )}
            </div>
          </div>
        ))}
        {comments.length === 0 && (
          <div style={{ color: '#999', textAlign: 'center', padding: '20px 0' }}>
            No comments yet.
          </div>
        )}
      </div>
      {isEdit && (
        <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
          <TextArea
            rows={6}
            placeholder="Enter comment..."
            value={commentText}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setCommentText(e.target.value)}
          />
          <Button
            type="primary"
            onClick={handleAddComment}
            style={{ marginTop: 12, width: '100%' }}
            disabled={!commentText.trim()}
          >
            Add Comment
          </Button>
        </div>
      )}
    </Card>
  );
};
